import { Input as MInput } from '@mantine/core';

// iOS Safari auto-zooms focused form controls when font-size < 16px.
export const Input = MInput.extend({
  vars: () => ({
    wrapper: {
      '--input-fz': '16px',
    },
  }),
});
